import styled from 'styled-components';

const H1 = styled.h1`
  color: #3e465b;
  font-size: 35px;
  line-height: 1.2;
  margin: 0;
  padding: 0 10px;
  text-align: center;
`;

export default H1;